import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.codigoTiUndMat} value={props.elemento._id}>{props.elemento.descrTiUndMat}</option>
  )
};

const Lista = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
    const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
    return(
        <div>
            <select className="ui simple selection dropdown fluid" name="tiundmat" id="miLista" value={permiteUpdate?argsDocum.idTiUndMat:idLista.tiundmat._id} onChange={(ev)=>handleChange(ev, argsDocum)}>
                {Nivel1Detalle}
            </select>
        </div>
    )
};

class VerUm2 extends React.Component {
    state={
        argsDocum: {descrUndMat: this.props.idLista.descrUndMat,
                    idTiUndMat: this.props.idLista.tiundmat._id,
                    codigoTiUndMat: this.props.idLista.tiundmat.codigoTiUndMat,
                    descrTiUndMat: this.props.idLista.tiundmat.descrTiUndMat,
                    _id: this.props.idLista._id},
        confirmaAct: false,
        open: false,
    }

    handleChange = (ev) => {
        if (this.props.permiteUpdate){
            this.setState({confirmaAct: false})
            // console.log(ev.target.name)
            // console.log(ev.target)
            // if(ev.target.name !== "descrUndMat"){
                const argsDocum = this.state.argsDocum
                if(ev.target.name === "tiundmat"){
//No se permite modificar la subclase => se comentan las lineas siguientes
                    // argsDocum['idTiUndMat'] = ev.target.value
                    // var miLista = document.getElementById("miLista");
                    // argsDocum['codigoTiUndMat'] = miLista.options[miLista.selectedIndex].attributes[0].value
                    // argsDocum['descrTiUndMat'] = miLista.options[miLista.selectedIndex].text
                }else{
                    argsDocum[ev.target.name] = ev.target.value 
                }
                this.setState({argsDocum});
            // }
        }
    }

    handleQuestionUpdDel = async (ev) => {
        var btnPress = await ev.target.attributes[0].value
        if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
        if(btnPress==="No"){
            this.setState({open: false})
        };
        if(btnPress==="Si"){
            this.setState({confirmaAct: true})
            this.setState({open: false})
            const myBtn = await document.getElementById("btnUpdDel");
            myBtn.click()
        }
    }

    render(){
        const {argsDocum, open, confirmaAct} = this.state;
        // console.log(this.props.list)
        // let listaTum = []
        // if(this.props.list){listaTum = this.props.list}
    
        // console.log("entro ver")
        return(
            <div>
                <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
                    <i className="large hand point down yellow icon"></i>
                    Unidad matriz
                </button>
                <div style={this.props.styles.box}>
                    <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
                        <div className="ui one column stackable grid">
                            <div className="row container">
                                <div className="column" width="100%">
                                    <Form.Field>
                                        <label style={this.props.styles.label}>Descripción</label>
                                        <Form.Input autoComplete="off" name="descrUndMat" id="descrUndMat" value={this.props.permiteUpdate?argsDocum.descrUndMat:this.props.idLista.descrUndMat} onChange={this.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrUndMat'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                    </Form.Field>
                                    <Form.Field>
                                        <label style={this.props.styles.label}>Tipo unidad matriz</label>
                                        <Lista list={this.props.list} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                                    </Form.Field>
                                    <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                                </div>
                                {
                                    this.props.errors.length?<Message negative header="Los siguientes errores:"
                                    list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                                }
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        )
    }
}

export default VerUm2
